import { format } from 'date-fns';
import { vi } from 'date-fns/locale';
import { motion } from 'framer-motion';
import useCalendarStore from '../../store/calendarStore';
import useThemeStore from '../../store/themeStore';

interface CalendarHeaderProps {
    isVisible: boolean;
    onClose: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ isVisible, onClose }) => {
    const { currentDate, goToToday } = useCalendarStore();
    const { openSelector, theme } = useThemeStore();

    if (!isVisible) return null;

    return (
        <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -100, opacity: 0 }}
            transition={{ type: 'spring', damping: 25 }}
            className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-lg"
        >
            <div className="flex items-center justify-between px-4 py-3 sm:py-4 text-white">
                {/* Month/Year Display */}
                <div className="flex-1">
                    <h2 className="text-lg sm:text-xl font-bold">
                        {format(currentDate, 'MMMM yyyy', { locale: vi })}
                    </h2>
                </div>

                {/* Theme Button - 44px touch target */}
                <button
                    onClick={openSelector}
                    className="p-2 hover:bg-white/20 rounded-full transition-colors mr-2 min-w-[44px] min-h-[44px] flex items-center justify-center touch-manipulation active:scale-95"
                    title="Đổi giao diện"
                >
                    <div
                        className="w-6 h-6 sm:w-7 sm:h-7 rounded-full border-2 border-white"
                        style={{ background: `linear-gradient(135deg, ${theme.gradient.from}, ${theme.gradient.to})` }}
                    />
                </button>

                {/* Today Button - 44px touch target */}
                <button
                    onClick={goToToday}
                    className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-full text-sm sm:text-base font-medium transition-colors mr-2 min-h-[44px] flex items-center justify-center touch-manipulation active:scale-95"
                >
                    Hôm nay
                </button>

                {/* Close Button - 44px touch target */}
                <button
                    onClick={onClose}
                    className="p-2 hover:bg-white/20 rounded-full transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center touch-manipulation active:scale-95"
                >
                    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </motion.div>
    );
};

export default CalendarHeader;
